import './mods/mod-1zpirit.js';
import './mods/mod-pdfgen.js';
import './mods/mod-tittlebreak.js';
import {List} from './libs/list.js';

// init typekit
try{Typekit.load({ async: true });}catch(e){}

(function ($, root, undefined) {
	
	jQuery(function () {
		
		'use strict';
		
		// btn aria-expanded
		jQuery('button[aria-expanded]').on('click', function(event) {
			if ( ! this.hasAttribute('aria-controls') ) {
				console.log( 'Button must have \'aria-controls\' attribute' );
				return;
			}

			// select all buttons who control the same element, ex open and seperate close btn
			var btn = jQuery('button[aria-controls="'+ this.getAttribute('aria-controls') +'"]');
			var controls = jQuery('#'+this.getAttribute('aria-controls'));
			
			// the tab trigger buttons, hide siblings and related triggers
			if ( this.className.indexOf('audience-tab-trigger') !== -1 ) {
				btn.siblings('button').attr('aria-expanded', 'false');
				jQuery('.audience-tab').attr('aria-expanded', 'false').find('button').attr('aria-expanded', 'false');
				// animate scroll to tabs
				jQuery('html, body').animate({ scrollTop: jQuery('.choose-audience').offset().top }, 1000);
			}

			// control siblings and hide them
			if ( this.hasAttribute('data-siblings') ) {
				var $el = jQuery(this).parent().siblings().find('button[data-siblings="true"]');
				$el.attr('aria-expanded', 'false');
				jQuery('#'+$el.attr('aria-controls')).attr('aria-expanded', 'false');
			}

			// toggle aria-expanded state
			if ( btn.attr('aria-expanded') === 'false' ) {
				btn.attr('aria-expanded', 'true');
				controls.attr('aria-expanded', 'true');
			}
			else {
				btn.attr('aria-expanded', 'false');
				controls.attr('aria-expanded', 'false');
			}

		});

		// scroll pagemenu fixedt
		var tId = null;
		var sp = 0;
		function scroll_pagemenu(el) {
			var mo = jQuery('#sub-hentry-menu').offset().top;
			var fm = jQuery('.page-section-menu');
			var fmp = jQuery('.page-section-menu').offset().left;
			tId = tId ? clearTimeout(tId) : null;
			sp = jQuery(el).scrollTop();

			tId = window.setTimeout(function() {
				if ( sp >= mo ) {
					fm.addClass('fixme');
					fm.css('left', fmp);
				}
				else {
					fm.removeClass('fixme');
					fm.css('left', 'auto');
				}

				tId = null;
			}, 50);
		}
		jQuery('a.page-section-link').on('click', function(event) {
			event.preventDefault();
			
			jQuery('html, body').animate({
				scrollTop: jQuery(this.getAttribute('href')).offset().top
			}, 1000);

			window.location.hash = this.getAttribute('href');
		});
		
		/**
		 * Pause video on modal close
		 */
		// TODO: Fix til nye video acf felt slik at video kan pause ved modal lukking
		// jQuery('#conexus-video').on( jQuery.modal.BEFORE_CLOSE, function(event, modal) {
		// 	this.childNodes[0].pause();
		// });

		/**
		 * Set height on reveal container 
		 * for css inheritance on older browsers.
		 *
		 * Usecase - set height minus header height.
		 */		
		var rc = document.querySelector('.reveal-container');
		var ph = document.querySelector('.header');
		function scale_reveal_container() {
			if ( rc && ph ) {
				rc.style.height = (window.innerHeight - ph.getBoundingClientRect().height) + 'px';
			}	
		}
		scale_reveal_container();
		window.onresize = scale_reveal_container;
		/**
		 * Reload page in reveal if mobile switches
		 */
		window.onorientationchange = function() { 
			if( rc )
				window.location.reload(); 
		};

		/**
		 * Fix for reveal ordered list numbers not bold
		 */
		var oli = document.querySelectorAll('.reveal section section ol li');
		if ( oli ) {
			for ( var li = 0; li < oli.length; li++ ) {
				oli[li].innerHTML = '<span>'+ oli[li].innerHTML +'</span>';
			}
		}

		/**
		 * All external links open in new tab
		 */
		var a = document.querySelectorAll('a[href^="http"], a[href^="//"]');
		for ( var i = 0; i < a.length; i++ ) {
			if ( a[i].hostname.indexOf( window.location.hostname ) === -1 ) {
				a[i].target = '_blank';
			}
		}

		// init the list of county selector
		var options_overlay = {
			valueNames: [ 'county-name' ]
		};
		var userList = new List('counties-overlay', options_overlay);

		const shortcuts = document.getElementById('shortcuts');
		let timeId;
		const fade_out_shortcuts = (e) => {
			if ( timeId )
				clearTimeout(timeId);

			timeId = setTimeout(
				() => {
					if ( window.scrollY >= 200 ) {
						shortcuts.className = 'fade-out';
					}
					else {
						shortcuts.className = '';
					}
				}, 100
			);
		};

		/**
		 * ===============================
		 * 
		 * ONLY GLOBAL HANLDERS BELOW THIS
		 *
		 * ===============================
		 */
		// CLOSE ELEMENTS ON ESCAPE KEY
		jQuery(window).on('keyup', function(event) {
			if ( event.keyCode === 27 ) {
				jQuery('[aria-expanded]').attr('aria-expanded', 'false');
			}
		});

		// close elements on click outside
		jQuery(document).on('click touchstart', function(event) {
			// nav-outside is not the click target
			if ( jQuery(event.target).closest('#nav-outside').length === 0 && jQuery(event.target).closest('.menu-trigger').length === 0 ) {
				jQuery('button[aria-controls="nav-outside"]').attr('aria-expanded', 'false');
				jQuery('#nav-outside').attr('aria-expanded', 'false');
			}
		});

		jQuery(window).on('scroll', function(event) {
			if ( document.querySelector('#sub-hentry-menu .page-section-menu') )
				scroll_pagemenu(this);

			fade_out_shortcuts(event);
		});

		// js is loaded
		document.body.className += ' loaded';
	});
	
})(jQuery, this);


// Create focus trap for county and main-menu
import * as focusTrap from 'focus-trap';

// Main menu modal
const mainMenuBtn = document.getElementById('menu-trigger');
mainMenuBtn.addEventListener('click', () => {
	const menu = document.getElementById('main-menu-outer');
	menu.classList.toggle('hidden');

	// create and activate focus trap
	const menuTrap = focusTrap.createFocusTrap(menu);
	menuTrap.activate();
	
	// handle Escape key
	window.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			menuTrap.deactivate();
			menu.classList.add('hidden');
		}
	});

	// handle close btn
	const closeBtn = document.getElementById('close-main-menu');
	closeBtn.addEventListener('click', () => {
		menuTrap.deactivate();
		menu.classList.add('hidden');
	});

	// close on click outside
	menu.addEventListener('click', (e) => {
		if (e.target.id === 'main-menu-outer') {
			menuTrap.deactivate();
			menu.classList.add('hidden');
		}
	});

	const fontSizeBtn = document.getElementById('fontsize-btn');
	const searchBtn = document.getElementById('search-trigger');
	const search = document.getElementById('searchform');
	const font = document.getElementById('fontsize-adjust');

	fontSizeBtn.addEventListener('click', () => {
		if (!search.classList.contains('hidden')) {
			search.classList.toggle('hidden');
		}
		font.classList.toggle('hidden');
	});
	searchBtn.addEventListener('click', () => {
		if (!font.classList.contains('hidden')) {
			font.classList.toggle('hidden');
		}
		search.classList.toggle('hidden');
	});



});

// County modal
const countyBtn = document.getElementById('county-trigger');
countyBtn.addEventListener('click', () => {
	// get county modal
	const county = document.querySelector('#counties-overlay-outer');

	// open modal
	county.classList.remove('hidden');
	
	// disable scroll on body 
	document.body.classList.add('disable-scroll');

	// activate focus trap
	const countyTrap = focusTrap.createFocusTrap(county);
	countyTrap.activate();

	// Add close event to close btn;
	const closeBtn = document.getElementById('close-counties-overlay');
	if (closeBtn) {
		closeBtn.addEventListener('click', () => {
			// disable focus trap
			countyTrap.deactivate();
			// enable scrolling on body
			document.body.classList.remove('disable-scroll');
			// hide county modal
			county.classList.add('hidden');	
		});
	}

	// close modal on escape.
	window.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			countyTrap.deactivate();	
			document.body.classList.remove('disable-scroll');
			county.classList.add('hidden');
		}
	});	

	// close modal on click outside.
	county.addEventListener('click', (e) => {
		if (e.target.id === 'counties-overlay-outer') {
			countyTrap.deactivate();
			document.body.classList.remove('disable-scroll');
			county.classList.add('hidden');
		} 
	});
});
